import i18n from './index';

export const translate = (key: string, options?: any) => {
  return i18n.t(key, options);
};

export { useTranslation, Trans } from 'react-i18next';